interface MasterSectionHeaderProps {
  expanded: boolean;
  onToggle: () => void;
  processCount: number;
  locationCount: number;
  detailLocationCount: number;
  size?: 'sm' | 'base';
}

/**
 * 사업장 관리 탭의 "대상 구성 마스터" 펼침/접힘 헤더.
 * Desktop/Mobile 양쪽에서 공유.
 */
export function MasterSectionHeader({
  expanded,
  onToggle,
  processCount,
  locationCount,
  detailLocationCount,
  size = 'base',
}: MasterSectionHeaderProps) {
  const titleSize = size === 'sm' ? 'text-sm' : 'text-base';
  const marginBottom = size === 'sm' ? 'mb-2 px-1' : 'mb-3';

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`w-full flex items-center gap-2 ${marginBottom} text-left hover:opacity-75 transition-opacity`}
      aria-expanded={expanded}
    >
      <svg
        className={`h-4 w-4 text-ink-500 transition-transform ${expanded ? 'rotate-90' : ''}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
      <div>
        <h3 className={`${titleSize} font-medium text-ink-900`}>
          대상 구성 마스터
          <span className="ml-2 text-xs font-normal text-ink-500">
            공종 {processCount} · 장소 {locationCount} · 위치 {detailLocationCount}
          </span>
        </h3>
        <p className="text-xs text-ink-500">대상 생성에 사용되는 선택지를 등록합니다.</p>
      </div>
    </button>
  );
}
